<app-auth-shell title="Confirmando conta" subtitle="Aguarde um instante">
  <div class="auth-confirm">
    <div class="auth-confirm__spinner" role="status" aria-label="Confirmando conta"></div>
    <p class="auth-confirm__text">Confirmando sua conta...</p>
  </div>
</app-auth-shell>
